"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushNotificationDtoSchema = exports.ImageUrlSchema = void 0;
const zod_1 = require("zod");
const types_1 = require("../jobs/types");
exports.ImageUrlSchema = zod_1.z.string().url({
    message: 'Invalid image URL',
});
exports.PushNotificationDtoSchema = zod_1.z.object({
    notification: zod_1.z.object({
        title: zod_1.z.string(),
        body: zod_1.z.string(),
        imageUrl: exports.ImageUrlSchema.optional(),
        type: types_1.PushNotifType,
    }),
    userIds: zod_1.z.array(zod_1.z.string()).nonempty({ message: 'User IDs are required' }),
});
